// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "product_location".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "product_location" table (1:1 with a DB row, on the wire). */
export const productLocationAtomSchema = z.object({
    id: z.string(),
    productId: z.string(),
    locationId: z.string(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=productLocation.js.map